<template>
    <div>
        <Header year="2026" :withLinks="false"></Header>
        <section class="box my-1 px-3 px-0-desktop">
            <div class="container">
                <div class="columns">
                    <div class="column is-half">
                        <h1 class="is-size-3">Pagament d'inscripció</h1>

                        <progress
                            v-if="loading"
                            class="progress is-primary is-half mt-5"
                            max="100"
                        ></progress>

                        <div v-else-if="error" class="notification is-danger mt-5">
                            {{ error }}
                        </div>

                        <div v-else-if="enrollment">
                            <p v-if="enrollment.competition.name" class="mt-3">
                                <strong>Competició:</strong>
                                {{ enrollment.competition.name }}
                            </p>
                            <p v-if="enrollment.pilot.name">
                                <strong>Pilot:</strong>
                                {{ enrollment.pilot.name }}
                            </p>
                            <p>
                                <strong>Import:</strong>
                                {{ amount }}
                            </p>

                            <div
                                v-if="enrollment.status === 'paid'"
                                class="notification is-success mt-5"
                            >
                                <i class="fas fa-check"></i>
                                Aquesta inscripció ja està pagada.
                            </div>

                            <progress
                                v-if="paying"
                                class="progress is-primary is-half mt-5"
                                max="100"
                            ></progress>
                            <button
                                v-else
                                class="button mt-5 w-100 is-primary"
                                v-on:click="pay"
                            >
                                {{
                                    enrollment.status === "paid"
                                        ? "Tornar a FlyTheHike"
                                        : "Pagar " + amount
                                }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Header from "../components/Header.vue";

const ERRORS = {
    PAYMENT_NOT_FOUND: "No hem trobat aquesta inscripció. Torna a FlyTheHike i torna-ho a provar.",
    PAYMENTS_NOT_CONFIGURED: "Els pagaments no estan disponibles ara mateix. Contacta amb l'organització.",
};
const GENERIC_ERROR = "No hem pogut contactar amb FlyTheHike. Torna-ho a provar d'aquí una estona.";

export default {
    name: "FlyTheHikePayment",
    components: {
        Header,
    },
    data() {
        return {
            reference: null,
            enrollment: null,
            error: null,
            loading: true,
            paying: false,
        };
    },
    computed: {
        amount() {
            if (!this.enrollment) return "";
            return (this.enrollment.amount_cents / 100).toLocaleString("ca-ES", {
                style: "currency",
                currency: "EUR",
            });
        },
    },
    methods: {
        handleError(data) {
            const code = data && data.error && data.error.code;
            this.error = ERRORS[code] || GENERIC_ERROR;
        },
        load() {
            fetch("/api/flythehike/enrollments/" + encodeURIComponent(this.reference), {
                headers: { Accept: "application/json" },
            })
                .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
                .then(({ ok, data }) => {
                    if (ok) this.enrollment = data;
                    else this.handleError(data);
                })
                .catch(() => this.handleError())
                .finally(() => {
                    this.loading = false;
                });
        },
        pay() {
            this.paying = true;

            fetch("/api/flythehike/checkout", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({ reference: this.reference }),
            })
                .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
                .then(({ ok, data }) => {
                    if (ok && (data.url || data.redirect)) {
                        document.location.href = data.url || data.redirect;
                        return;
                    }
                    this.handleError(data);
                    this.paying = false;
                })
                .catch(() => {
                    this.handleError();
                    this.paying = false;
                });
        },
    },
    mounted() {
        this.$root.$emit("ready");
        this.reference = this.$route.query.client_reference_id;

        if (!this.reference) {
            this.error = ERRORS.PAYMENT_NOT_FOUND;
            this.loading = false;
            return;
        }

        this.load();
    },
};
</script>
